export const Collections = {
  USERS: "users",
  STAGES: "stages",
  LOGS: "logs",
  PERSONS: "persons",
  RATINGS: "ratings",
  REVIEWS: "reviews",
  MAILBOX: "mailbox",
  EMAILS: "emails",
};
